export function shopVisibilityChanges(current, action) {
  if (action === 'restore') {
    return { adminDeleted: false, adminDisabled: false, published: true, publishedBeforeDisable: true };
  }
  if (current.adminDeleted) throw new Error('This shop is deleted. Use Restore before enabling it.');
  if (action === 'delete') return { adminDeleted: true, adminDisabled: true, published: false };
  if (action === 'enable') return { adminDisabled: false, published: current.publishedBeforeDisable !== false };
  if (action === 'disable') return {
    adminDisabled: true,
    published: false,
    publishedBeforeDisable: current.adminDisabled ? current.publishedBeforeDisable !== false : current.published !== false,
  };
  throw new Error('Unknown shop action.');
}
